import Feature22 from './Feature22'
export default Feature22
